import { AutocompleteOption } from '@types'

export const enum DIAGRAMS_TABS {
  AXISX,
  COLUMNS,
  VIEW,
}

export const enum AXIS_TYPE {
  TIME = 'TIME',
  OBJECT = 'OBJECT',
}

export const axisXOptions: AutocompleteOption[] = [
  { label: 'Time', id: AXIS_TYPE.TIME },
  { label: 'Object', id: AXIS_TYPE.OBJECT },
]

export const enum PERIOD_TYPE {
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
  YEAR = 'YEAR',
}

export const periodOptions: AutocompleteOption[] = [
  { label: 'Day', id: PERIOD_TYPE.DAY },
  { label: 'Week', id: PERIOD_TYPE.WEEK },
  { label: 'Month', id: PERIOD_TYPE.MONTH },
  { label: 'Year', id: PERIOD_TYPE.YEAR },
]

export const enum INCREMENT_TYPE {
  MINUTE = 'MINUTE',
  HOUR = 'HOUR',
  DAY = 'DAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
}

export const incrementOptions: AutocompleteOption[] = [
  { label: '1 minute', id: INCREMENT_TYPE.MINUTE },
  { label: '1 hour', id: INCREMENT_TYPE.HOUR },
  { label: '1 day', id: INCREMENT_TYPE.DAY },
  { label: '1 week', id: INCREMENT_TYPE.WEEK },
  { label: '1 month', id: INCREMENT_TYPE.MONTH },
]
